import { ClickEvent, Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutDetentionHistoryTable } from "./autogen/AutogenLayoutDetentionHistoryTable";
import { ModelRow, StringUtil, Navigation } from "@mcleod/core";

export class DetentionHistoryTable extends AutogenLayoutDetentionHistoryTable {

    tableDetentionHistoryOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow: ModelRow = tableRow.data;
        const labelOrderId = tableRow.findComponentById("labelOrderId") as Label;
        if (labelOrderId) {
            labelOrderId.applyLinkStyle();
        }
    }

    labelOrderIdOnClick(event: ClickEvent) {
        const label = event.target as Label;
        if (!StringUtil.isEmptyString(label.text)) {
            Navigation.navigateTo(`lme/dispatch/OrderTabView?mode=update&key=${label.text}`, {newTab: true});
        }
    }
}
